import store from 'store'
import nanoid from 'nanoid'

export default {
  methods: {
    initModelByHash (hash) {
      this.model = store.get(hash)
    },
    getModelByHash (hash) {
      return store.get(hash)
    },
    generateHash () {
      return new Promise((resolve) => {
        const hash = nanoid()

        store.set(hash, this.model)

        resolve(hash)
      })
    }
  }
}
